var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41872 3.27978C1.41872 2.58347 1.98349 2.01869 2.6798 2.01869H13.3202C14.0165 2.01869 14.5813 2.58347 14.5813 3.27978V3.64508L8.00018 7.20244L1.41872 3.64489V3.27978ZM1.41872 5.25761V10.7675C1.41872 11.4638 1.98349 12.0285 2.6798 12.0285H13.3202C14.0165 12.0285 14.5813 11.4638 14.5813 10.7675V5.2578L8.33749 8.63282C8.12701 8.7466 7.87335 8.7466 7.66287 8.63282L1.41872 5.25761ZM2.6798 0.599976C1.19996 0.599976 0 1.79993 0 3.27978V10.7675C0 12.2473 1.19996 13.4473 2.6798 13.4473H13.3202C14.8 13.4473 16 12.2473 16 10.7675V3.27978C16 1.79993 14.8 0.599976 13.3202 0.599976H2.6798Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c58a7ff839da6758125e1f106c000f4f.svg";
export { ForwardRef as ReactComponent };